import React from 'react';
import { extensions, i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import common from '../constants/common';
import Trigger from '../../../../common/components/trigger';
import canBeMovedBackward from '../helpers/can-be-moved-backward';
import canBeMovedForward from '../helpers/can-be-moved-forward';
import MoveOnFront from '../components/move-on-front';
import MoveOnBackground from '../components/move-on-background';
import MoveBackward from '../components/move-backward';
import MoveForward from '../components/move-forward';

const { Icon } = designSystem;
const { REORDER_COMPOSITE_WIDGET_TRIGGER_ID } = common;

const reorderLayersControl = {
  id: REORDER_COMPOSITE_WIDGET_TRIGGER_ID,
  trigger: (
    <Trigger id={REORDER_COMPOSITE_WIDGET_TRIGGER_ID}>
      <Icon glyph="pages" />
    </Trigger>
  ),
  closeIcon: 'submit',
  header: (elementId) => [
    <MoveOnBackground elementId={elementId} />,
    <MoveBackward elementId={elementId} />,
    <MoveForward elementId={elementId} />,
    <MoveOnFront elementId={elementId} />,
  ],
  body: null,
  get tooltip() {
    return i18next.t('Reorder');
  },
  matches(liveElement) {
    const settings = extensions.accessors.getExtensionSettings(common.slug);
    const isMatched = liveElement.matches(settings.elementToReorderSelector);

    if (!isMatched) return false;

    return canBeMovedBackward(liveElement) || canBeMovedForward(liveElement);
  },
  priority: 50,
};

export default reorderLayersControl;
